import React from 'react';
import { Router } from '@uhg-abyss/web/ui/Router';
import { AppBody } from '../common/AppBody';
import { GlobalErrorDialog } from '../common/ErrorHandler';
import { AuthCallback } from './AuthCallback';
import { Home } from './Home';
import { ProtectedShell } from './ProtectedShell';
import { RfiInfo } from './RfiInfo';
import { Survey } from './Survey';
import { AdminShell, QuestionsListPage, QuestionEditorPage, BranchingPage, SurveyListPage, UdwBatchJobsPage } from './Admin';
import { Reports } from './Reports';
import { HistoricalData } from './HistoricalData';
import { SignedOut } from './SignedOut';

export const Routes = () => {
  return (
    <React.Fragment>
      <GlobalErrorDialog />
      <Router.Routes title="{{title}}">
        <Router.Route path="/auth/callback" element={<AuthCallback />} />
        <Router.Route path="/signed-out" element={<SignedOut />} />
        <Router.Route path="/" element={<ProtectedShell />}>
          <Router.Route path="/" element={<AppBody />}>
            <Router.Route path="/" element={<Home />} />
            <Router.Route path="/home" element={<Home />} />
            <Router.Route path="/historicdata" element={<HistoricalData />} />
            <Router.Route path="/rfiinfo" element={<RfiInfo />} />
            <Router.Route path="/survey/entry/:entryId" element={<Survey />} />
            <Router.Route path="/reports" element={<Reports />} />

            {/* Admin sub-tree — ADMIN role required (enforced by AdminShell) */}
            <Router.Route path="/admin" element={<AdminShell />}>
              <Router.Route path="surveys" element={<SurveyListPage />} />
              <Router.Route path="questions" element={<QuestionsListPage />} />
              <Router.Route path="questions/new" element={<QuestionEditorPage />} />
              <Router.Route path="questions/:questionId/edit" element={<QuestionEditorPage />} />
              <Router.Route path="questions/:questionId/branching" element={<BranchingPage />} />
              <Router.Route path="udw-batch-jobs" element={<UdwBatchJobsPage />} />
            </Router.Route>
          </Router.Route>
        </Router.Route>
      </Router.Routes>
    </React.Fragment>
  );
};
